module.exports = __webpack_public_path__ + "img/refresh@2x.0f44de2f.png";